import { useState } from "react"
import axiosInstance from "../axios/axiosConfig"
import { message } from "antd"

const useSerachKnifeWithButton = () => {
  const [knifeData, setKnifeData] = useState([])
  const [knifeLoading, setKnifeLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchDataWithSearch = async (
    searchByCode,
    width,
    height,
    range,
    selectedShape,
    knifeNumber,
    selectedMachine
  ) => {
    if (!searchByCode && (width === null || height === null)) {
      message.error("Please enter a code or both width and height.")
      return
    }
    setKnifeData([])
    setKnifeLoading(true)
    setError(null)
    try {
      const response = await axiosInstance.get(`/api/search`, {
        params: { code: searchByCode, width, height, range, shape: selectedShape },
      })

      const knifeResults = response.data

      const transformedResults = knifeResults.map((knife) => ({
        id: knife.id.toString(),
        code: knife.code, // Changed from lowercase to uppercase to match backend
        width: parseFloat(knife.width), // Changed from lowercase to uppercase
        height: parseFloat(knife.height), // Changed from lowercase to uppercase
        Radius: parseFloat(knife.Radius), // Added this line
        DATE_X: knife.DATE_X, // Added this line
        TypeOfForm: knife.TypeOfForm, // Added this line
        SHAPE: knife.SHAPE, // Added this line
        Client: knife.Client, // Added this line
        rowss: parseInt(knife.rowss, 10), // Added this line
        spaceBetweenRows: parseInt(knife.spaceBetweenRows, 10), // Added this line
        Form_Rows: parseInt(knife.Form_Rows, 10), // Added this line
        gapRaport: parseFloat(knife.gapRaport), // Added this line
        Z: parseInt(knife.Z, 10), // Added this line
        Z_raports: parseFloat(knife.Z_raports), // Added this line
        Rotary_Or_SemiRotary: knife.Rotary_Or_SemiRotary, // Added this line
        Knives_WIDTH_mm: parseInt(knife.Knives_WIDTH_mm, 10), // Added this line
        Material_width: parseInt(knife.Material_width, 10), // Added this line
        m_for_1k: parseInt(knife.m_for_1k, 10), // Added this line
        Used_Or_New: knife.Used_Or_New, // Added this line
        Cutter_Knives_Width_until_313mm: knife.Cutter_Knives_Width_until_313mm, // Changed from lowercase to uppercase to match backend
        Arsoma_knife_width_until_275mm_Z: knife.Arsoma_knife_width_until_275mm_Z, // Changed from lowercase to uppercase to match backend
        EM_340_knife_width_until_325_Z: knife.EM_340_knife_width_until_325_Z, // Changed from lowercase to uppercase to match backend
        VIVA_340_Minimal_paper_width_160mm: knife.VIVA_340_Minimal_paper_width_160mm, // Changed from lowercase to uppercase to match backend
        Hot_Foil: knife.Hot_Foil,
      }))

      if (knifeNumber <= 0) {
        //checks if it should filter
        let filteredByMachine = transformedResults // Default to all results

        switch (selectedMachine) {
          case "Arsoma":
            filteredByMachine = transformedResults.filter(
              (knife) => knife.Arsoma_knife_width_until_275mm_Z === true
            )
            break
          case "Viva":
            filteredByMachine = transformedResults.filter(
              (knife) => knife.EM_340_knife_width_until_325_Z === true || knife.Hot_Foil === true
            )
            break
          case "Cutter":
            filteredByMachine = transformedResults.filter(
              (knife) => knife.Cutter_Knives_Width_until_313mm === true
            )
            break
          default:
            // Optionally handle any other specific scenario or do nothing to keep the default all results
            break
        }

        // Set the filtered results to the state
        setKnifeData(filteredByMachine)
      } else {
        // If knifeNumber is not <= 0, just set the transformed results to the state
        setKnifeData(transformedResults)
      }
    } catch (error) {
      console.error("Failed to fetch data:", error)
      setError(error)
      message.error("error happened")
    } finally {
      setKnifeLoading(false)
    }
  }

  return { knifeData, knifeLoading, error, fetchDataWithSearch }
}

export default useSerachKnifeWithButton
